const LOOPBACK_HOSTNAME_REGEX = /^(?:127(?:\.\d+){3}|\[?::1\]?|localhost)$/i;

/** Whether a URL hostname is this device's own loopback (`127.x.x.x`, `::1`, `localhost`). */
export function isLoopbackHostname(hostname: string): boolean {
  return LOOPBACK_HOSTNAME_REGEX.test(hostname);
}
